import React from 'react';
import { connect } from 'react-redux';
import { WheelsProfileContainerStyled } from './styled';
import { adminService } from 'apiService';
import { toast } from 'react-toastify';
import { setReduxUserAuth } from 'actions';
import { WheelsForm } from 'forms/AdminFormSystem';

class WheelsProfileContainer extends React.Component {
  state = {};

  componentDidMount() {
    const { slugId } = this.props;
    if (slugId) {
      this.fetchData();
    }
  }

  fetchData = async () => {
    const { slugId } = this.props;
    let res = await adminService.GET_WHEELS_DETAIL(slugId);
    // console.log("ressssss", res)
    if (res && res.success) {
      this.setState({
        data: res.data,
        initialValues: {
          ...res.data,
        },
      });
    }
  };

  handdleSave = async () => {
    const {
      reduxForm: { values, syncErrors },
      slugId,
      callback,
    } = this.props;
    let params = {
      ...values,
      is_active: values && values.is_active ? values.is_active : 0,
    };

    // console.log("parammmm ", slugId, params)
    if (typeof syncErrors === 'object') {
      toast.error('กรุณากรอกข้อมูลให้ครบถ้วน', {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else {
      if (!slugId) {
        let res = await adminService.POST_WHEELS_ADD(params);
        // console.log("ressssssssssssss ", res)
        if (res && res.success) {
          toast.success('บันทึกสำเร็จ');
          callback && callback(res.data.slug);
        } else {
          toast.error('Slug นี้มีข้อมูลแล้วกรุณาเปลี่ยน');
        }
      } else {
        let res = await adminService.PATCH_WHEELS_UPDATE(slugId, params);
        // console.log("ressssssssssssss ", res)
        if (res && res.success) {
          toast.success('บันทึกสำเร็จ');
        } else {
          toast.error('Slug นี้มีข้อมูลแล้วกรุณาเปลี่ยน');
        }
      }
    }
  };

  render() {
    const { initialValues } = this.state;
    return (
      <WheelsProfileContainerStyled>
        <WheelsForm
          initialValues={initialValues}
          handdleSave={this.handdleSave}
        />
      </WheelsProfileContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authRedux: state.auth,
  reduxForm: state.form.WheelsForm,
});

const mapDispatchToProps = (dispatch) => ({
  setReduxUserAuth: (data) => dispatch(setReduxUserAuth(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WheelsProfileContainer);
